// extracted by mini-css-extract-plugin
export var colCta = "_8wPLz";
export var meals = "_8JEAp";
export var progress = "IP0hF";
export var spacerWorkouts = "jYt1q";
export var viewMoreCta = "IxP38";
export var wellbeing = "cDxZ8";
export var workouts = "_5Vtql";